module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")]), _vm._v(" "), (_vm.entity.id) ? _c('div', {
    class: [_vm.tab === 'builder' ? 'active' : ''],
    on: {
      "click": _vm.goToBuilder
    }
  }, [_vm._v("Builder")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabs tabs-right hide-small"
  }, [_c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))]), _vm._v(" "), _c('div', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-tab'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show-small dropdown-admin-tabs"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Main details\n          "), (_vm.tab === 'main') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]), _vm._v(" "), (_vm.entity.id) ? _c('li', {
    on: {
      "click": _vm.goToBuilder
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n          Builder\n          "), (_vm.tab === 'builder') ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate))])]), _vm._v(" "), _c('li', {
    class: [_vm.isValid ? 'valid' : 'disabled', 'save-dropdown'],
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.saveOrUpdate) + " & exit")])])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [(_vm.tab === 'builder') ? _c('Builder', {
    attrs: {
      "countries": _vm.countries
    },
    on: {
      "addLocations": _vm.addLocations,
      "removeLocation": _vm.removeFromSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab === 'main'),
      expression: "tab === 'main'"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left top-small"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Vendor")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.partySearchResults,
      "title": "Vendor",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.vendor,
      "fnFormatText": _vm.displayParty,
      "fnSelectValue": _vm.displayParty
    },
    on: {
      "changing": function (data) { return _vm.partySearchText = data; },
      "selection-made": _vm.selectVendor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "vz-nm"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.location.name),
      expression: "entity.location.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "vz-nm"
    },
    domProps: {
      "value": (_vm.entity.location.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.location, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "vz-extId"
    }
  }, [_vm._v("External ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.externalId),
      expression: "entity.externalId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "vz-extId"
    },
    domProps: {
      "value": (_vm.entity.externalId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "externalId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 main-location-details left bottom-small"
  }, [(_vm.entity.id) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Add vendor zone location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Vendor Zone Location",
      "placeHolder": "Type to search",
      "initVal": _vm.vendorZoneLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectVendorLocation
    }
  })], 1), _vm._v(" "), _c('vue-table', {
    attrs: {
      "showDelete": true,
      "allow-select": true,
      "show-select-all": true,
      "tableData": _vm.vendorLocations.filter(function (zone) { return zone.deleted !== 1; }),
      "tableTitle": "Vendor Zone Locations",
      "fields": _vm.fields,
      "maxItems": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.removeLocation,
      "pages-remaining": _vm.loadMore,
      "select-all": _vm.removeSelectedLocations
    }
  })], 1) : _c('div', {
    staticClass: "mt-20 mb-15"
  }, [_c('p', [_vm._v("Once you have saved the vendor zone, you will be able to add locations")])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Options\n      "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308cdabb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/VendorZone/VendorZone.vue
// module id = 2134
// module chunks = 1